import { INode } from '../components/organisms/react-hierarchy-chart/dist';
import { Tcity, initialCity } from './city';
import { Tdistrict, initialDistrict } from './district';
import { TmaritalStatus, initialMaritalStatus } from './maritalStatus';
import { TmemberType, initialMemberType } from './memberType';
import { Tprovinsi, initialProvinsi } from './provinsi';
import { TroleGroup } from './roleGroup';
import { TuserType } from './userType';

export interface Tusers extends INode {
	id?: number;
	uniqueId?: string;
	children?: Tusers[];
	code: string;
	identityNumber1: string;
	identityNumber2: string;
	roles?: TroleGroup;
	nickName: string;
	fullName: string;
	gender: string;
	birthDate: string;
	placeOfBirth: string;
	memberType: TmemberType;
	maritalStatus?: TmaritalStatus;
	email: string;
	userName: string;
	phone?: string;
	provinsi: Tprovinsi;
	city: Tcity;
	district: Tdistrict;
	address1: string;
	address2: string;
	token?: string;
	thumbnail?: string;
	password: string;
	joinDate: string;
	reffCode: string;
	block: boolean;
	userType?: TuserType;
	salesReffCode: string;
	register?: Boolean;
}

export const initialUsers: Tusers = {
	children: [],
	code: '',
	identityNumber1: '',
	identityNumber2: '',
	nickName: '',
	fullName: '',
	gender: '',
	birthDate: '',
	placeOfBirth: '',
	memberType: initialMemberType,
	maritalStatus: initialMaritalStatus,
	email: '',
	userName: '',
	phone: '',
	provinsi: initialProvinsi,
	city: initialCity,
	district: initialDistrict,
	address1: '',
	address2: '',
	password: '',
	joinDate: '',
	reffCode: '',
	block: false,
	salesReffCode: '',
};
